import React, { useState, useEffect } from "react";
import "../commanComponents.css";

export default function PaginationButton({ page = 1, setPage, totalPages = 1, pageName, totalEntries = 0, limit = 10 }) {
  const startEntry = totalEntries === 0 ? 0 : (page - 1) * limit + 1;
  const endEntry = Math.min(page * limit, totalEntries || page * limit);
  const [inputVal, setInputVal] = useState(page);

  useEffect(() => {
    setInputVal(page);
  }, [page]);

  const handlePageChange = (val) => {
    const num = parseInt(val, 10);
    if (!isNaN(num) && num >= 1 && num <= totalPages) {
      localStorage.setItem(pageName, num);
      setPage(num);
    } else {
      setInputVal(page); // reset if invalid
    }
  };

  return (
    <div className="paginationContainer d-flex justify-content-between align-items-center  mt-3 pb-2 px-2">
      {/* <div className="paginationInfo text-muted" style={{ fontSize: "14px", fontWeight: "500" }}>
        Showing {startEntry} to {endEntry} of {totalEntries || (totalPages * limit)} entries
      </div> */}
      
      <div className="premiumPaginationWrapper">
        <input
          type="number"
          value={inputVal}
          min="1"
          max={totalPages}
          onChange={(e) => setInputVal(e.target.value)}
          onBlur={() => handlePageChange(inputVal)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handlePageChange(inputVal);
            }
          }}
          className="premiumPaginationInput"
        />
        
        <span className="premiumPaginationText">
          of {totalPages} {totalPages === 1 ? "Page" : "Pages"}
        </span>
        
        <button
          disabled={page === 1}
          className={`premiumPaginationBtn ${page > 1 ? "btnActive" : ""}`}
          onClick={() => {
            localStorage.setItem(pageName, page - 1);
            setPage(page - 1);
          }}
        >
          <svg viewBox="0 0 24 24">
            <polyline points="15 18 9 12 15 6"></polyline>
          </svg>
        </button>
        
        <button
          disabled={page >= totalPages || totalPages === 0}
          className={`premiumPaginationBtn ${page < totalPages && totalPages > 0 ? "btnActive" : ""}`}
          onClick={() => {
            localStorage.setItem(pageName, page + 1);
            setPage(page + 1);
          }}
        >
          <svg viewBox="0 0 24 24">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </button>
      </div>
    </div>
  );
}
